export default "__VITE_ASSET__1708b685__"